<template>
    <div>
        <Card>
            <p slot="title">
                Histori
            </p>
            <Row type="flex" justify="start" align="middle" class="code-row-bg" :gutter="16">
                <Col span="5">
                    <Select placeholder="Ketik Marking" v-model="markingIdSelected" filterable clearable remote
                        :remote-method="getMarkingByCode" :loading="loadingGetMarking">
                        <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">{{ option.label
                            }}
                        </Option>
                    </Select>
                </Col>
                <Col span="5">
                    <DatePicker v-model="dateFromTo" type="daterange" format="d MMM yyyy" split-panels placeholder="Select payment date" style="width: 200px"></DatePicker>
                </Col>
                <Col span="3">
                    <Button v-show="showSearchButton()" type="primary" :loading="loadingSearch" @click="markingIdSelected ? getPaymentMarking() : getPayment()"
                        icon="ios-search">
                        <span v-if="!loadingSearch">Cari</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </Col>
            </Row>

            <div v-show="progressGet > 0">
                <br/>
                <p>Processing...</p>
                <Progress :percent="progressGet"></Progress>
            </div>


            <br />
                <template v-if="payments.length > 0">
                    <Tag color="green">Total : Rp {{ total | numberFormatted }}</Tag>
                    <Tag color="blue" v-if="totalPayment > 0">Pembayaran : Rp {{ totalPayment | numberFormatted }}</Tag>

                    <vue-csv-downloader v-if="totalDiscount > 0" :data="paymentsDiscCsv" :fields="fieldCsv"
                        :download-name="csvName">
                        &nbsp;
                        <Tag color="red">Potongan : Rp {{ totalDiscount | numberFormatted }}</Tag>
                    </vue-csv-downloader>

                    <vue-csv-downloader v-if="totalReceivables > 0" :data="receivablesListCsv"
                        :fields="fieldReceivablesListCsv" :download-name="csvReceivablesName">
                        &nbsp;
                        <Tag color="purple">Total Piutang Manual : Rp {{ totalReceivables | numberFormatted }}</Tag>
                    </vue-csv-downloader>

                    <br><br>
                    <Table :columns="tableColumns" :data="payments" no-data-text="" ref="table"></Table>

                </template>


                <template v-if="allPayments.length > 0">

                    <Card :padding="8">
                        <Button type="success" size="small">Total : Rp {{ total | numberFormatted }}</Button> &nbsp;
                        <Button type="primary" size="small" v-if="totalPayment > 0">Pembayaran : Rp {{ totalPayment | numberFormatted }}</Button>
                        <vue-csv-downloader v-if="totalDiscount > 0" :data="paymentsDiscCsv" :fields="fieldCsv"
                            :download-name="csvName">
                            &nbsp;
                            <!-- <Tag color="red">Potongan : Rp {{ totalDiscount | numberFormatted }}</Tag> -->
                            <ButtonGroup size="small">
                                <Button type="error" >
                                    Potongan : Rp {{ totalDiscount | numberFormatted }}
                                </Button>
                                <Button type="ghost" >CSV</Button>
                            </ButtonGroup>
                        </vue-csv-downloader>

                        <vue-csv-downloader v-if="totalReceivables > 0" :data="receivablesListCsv"
                            :fields="fieldReceivablesListCsv" :download-name="csvReceivablesName">
                            &nbsp;
                            <ButtonGroup size="small">
                                <Button type="warning" >
                                    Total Piutang Manual : Rp {{ totalReceivables | numberFormatted }}
                                </Button>
                                <Button type="ghost" >CSV</Button>
                            </ButtonGroup>

                        </vue-csv-downloader>

                    </Card>
                    <br/>
                    <Row type="flex" justify="end" style="margin-bottom: 16px">
                        <Col span="8">
                            <Input v-model="searchQuery"
                                   placeholder="Cari berdasarkan tanggal, marking, atau deskripsi..."
                                   icon="ios-search"
                                   @on-change="handleSearch">
                            </Input>
                        </Col>
                    </Row>
                    <Table :columns="tableColumns" :data="paginatedPayments" no-data-text="" ref="table"></Table>
                    <br/>
                    <Page :total="filteredPayments.length"
                          :current="currentPage"
                          :page-size="pageSize"
                          show-total
                          show-sizer
                          show-elevator
                          :page-size-opts="[50, 100, 200, 500, 1000]"
                          @on-change="changePage"
                          @on-page-size-change="changePageSize"/>
                </template>
        </Card>

    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import VueCsvDownloader from 'vue-csv-downloader';

const numeral = require('numeral');
const axios = require('axios');

export default {
    data: () => ({
        markingIdSelected: '',
        optionMarkings: [],
        progressGet: 0,
        csvName: 'Potongan.csv',
        loadingGetMarking: false,
        loadingSearch: false,
        isOnlyBca: false,
        payments: [],
        allPayments: [], // Store all payments
        filteredPayments: [], // Store filtered payments
        searchQuery: '', // Search query
        currentPage: 1,
        pageSize: 100,
        paymentsDiscCsv: [],
        fieldRawCsv: ['paymentDate', 'markingheadercode', 'branchcode', 'deptNames', 'description', 'descriptionClaim', 'creditAmount', 'depositClaim'],
        fieldCsv: ['tanggal', 'marking', 'cabang', 'divisi', 'deskripsi', 'deskripsiClaim', 'potongan', 'deposit'],
        totalPayment: 0,
        dateFromTo: [],
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        tableColumns: [
            {
                type: 'index',
                width: 60,
                align: 'center'
            },
            {
                title: 'Tgl',
                key: 'paymentDate',
                width: 120,
                sortable: true
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                width: 150,
                sortable: true
            },
            {
                title: 'Kategori',
                key: 'categoryLabel',
                width: 110,
                type: 'html',
                sortable: true
            },
            {
                title: 'Jumlah',
                align: 'right',
                width: 120,
                key: 'creditAmount',
                sortable: true
            },
            {
                title: 'Detail',
                type: 'html',
                align: 'left',
                key: 'descriptionDetail',
                sortable: false
            }


        ],
        filterInput: '',
        totalDiscount: 0,
        total: 0,
        totalReceivables: 0,

        csvReceivablesName: 'Piutang Manual.csv',
        receivablesListCsv: [],
        fieldRawReceivablesListCsv: ['transactionDate', 'markingheadercode', 'branchcode', 'description', 'debitAmount'],
        fieldReceivablesListCsv: ['Tanggal', 'Marking', 'Cabang', 'Deskripsi', 'Piutang'],
    }),
    components: {
        VueCsvDownloader,
    },

    computed: {
        paginatedPayments() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredPayments.slice(start, end);
        }
    },

    methods: {
        changePage(page) {
            this.currentPage = page;
        },
        changePageSize(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1; // Reset to first page when page size changes
        },
        handleSearch() {
            const query = this.searchQuery.toLowerCase().trim();

            if (!query) {
                // If search is empty, show all payments
                this.filteredPayments = [...this.allPayments];
            } else {
                // Filter payments based on search query
                this.filteredPayments = this.allPayments.filter(payment => {
                    // Search in paymentDate
                    if (payment.paymentDate && payment.paymentDate.toLowerCase().includes(query)) {
                        return true;
                    }
                    // Search in markingheadercode
                    if (payment.markingheadercode && payment.markingheadercode.toLowerCase().includes(query)) {
                        return true;
                    }
                    // Search in description (plain text)
                    if (payment.description && payment.description.toLowerCase().includes(query)) {
                        return true;
                    }
                    // Search in descriptionDetail (strip HTML tags first)
                    if (payment.descriptionDetail) {
                        // Remove HTML tags to get plain text
                        const plainText = payment.descriptionDetail.replace(/<[^>]*>/g, ' ').toLowerCase();
                        if (plainText.includes(query)) {
                            return true;
                        }
                    }
                    // Search in branch code
                    if (payment.branchcode && payment.branchcode.toLowerCase().includes(query)) {
                        return true;
                    }
                    // Search in category
                    if (payment.category && payment.category.toLowerCase().includes(query)) {
                        return true;
                    }
                    return false;
                });
            }

            // Reset to first page when searching
            this.currentPage = 1;
        },
        generateCsvName: function (dateFrom, dateTo) {
            let csvName = 'Potongan '
            csvName += (dateFrom == dateTo) ? dateFrom : dateFrom + ' ' + dateTo
            csvName += '.csv'
            return csvName;
        },
        getPaymentHistory: function (payload) {
            return HTTP.post('payment/history', payload);
        },
        getReceivablesListManual: function (payload) {
            return HTTP.post('receivable/list-manual', payload);
        },
        getReceivablesTotalManual: function (payload) {
            return HTTP.post('receivable/total-manual', payload);
        },
        getPaymentMarking: function () {
            this.payments = []; // reset data
            this.allPayments = []; // reset all payments
            this.filteredPayments = []; // reset filtered payments
            this.loadingSearch = true;
            let dateCreateFrom = moment(this.dateFromTo[0], 'YYYY-MM-DD', true)
            let dateCreateTo = moment(this.dateFromTo[1], 'YYYY-MM-DD', true)

            let dateCreateFromValid = dateCreateFrom.isValid() == false ? '' : dateCreateFrom.format("YYYY-MM-DD");
            let dateCreateToValid = dateCreateTo.isValid() == false ? '' : dateCreateTo.format("YYYY-MM-DD");

            this.csvName = this.generateCsvName(dateCreateFromValid, dateCreateToValid)

            let payload = {
                markingHeaderId: this.markingIdSelected,
                dateCreateFrom: dateCreateFromValid,
                dateCreateTo: dateCreateToValid
            }

            axios.all([
                this.getPaymentHistory(payload),
                this.getReceivablesListManual(payload),
                this.getReceivablesTotalManual(payload),
            ]).then(axios.spread((paymentHistories, receivablesList, receivablesTotal) => {
                let parent = this;

                parent.totalPayment = 0
                parent.totalDiscount = 0
                parent.total = 0
                parent.totalReceivables = receivablesTotal.data

                let payments = []
                _.forEach(paymentHistories.data, function (value) {
                    let isShow = true;

                    if (parent.isOnlyBca) {
                        if (_.includes(value.receivable.description, 'BCA')) {
                            isShow = true
                        } else {
                            isShow = false
                        }
                    }

                    if (isShow) {
                        console.log('---------')
                        console.log(value.id)
                        console.log(value.markingHeaderId)
                        console.log('value.payment_allocate size = ' + value.payment_allocate.length)


                        let invoiceDetails = '';
                        let deptNames = []
                        _.forEach(value.payment_allocate, function (payAllocate) {
                            if (!payAllocate.invoice_due) {
                              parent.$Notice.warning({
                                  title: "Perhatian",
                                  desc: `
                                    Pembayaran ${value.receivable.marking_minified.markingheadercode},
                                    tanggal ${parent.showDateFormatted(value.paymentDate)} tidak ditemukan`,
                                  duration: 0
                              });
                            }

                            if (payAllocate.invoice_due.receivable != null) {
                                let paymentSum = payAllocate.invoice_due.paymentSum
                                paymentSum = numeral(paymentSum).format('0,0.00')

                                let deptName = ""
                                if (payAllocate.invoice_due.receivable.invoice != null) {
                                    deptName = payAllocate.invoice_due.receivable.invoice.item_dept.deptName
                                }

                                deptNames.push(deptName)
                                let invoiceDetail = "- " + deptName
                                invoiceDetail += " - " + payAllocate.invoice_due.receivable.description + " - Rp " + paymentSum
                                invoiceDetails += invoiceDetail + " <br/>"

                            }
                        });

                        // csv potong, detail claim
                        let detailClaim = ''
                        let obj = value.claim
                        if (obj) {
                            obj.claim_detail.forEach(o => {
                                detailClaim += o.description
                            })
                        }

                        let depositClaim = 0
                        if (value.claim) {
                            if (value.receivable.type == "DEP") {
                                depositClaim = value.claim.total_claim
                            } else {
                                depositClaim = value.claim.total_claim - value.amount
                            }

                            // depositClaim = value.claim.total_claim - value.amount
                            // if(depositClaim < 0) {
                            //   depositClaim = 0
                            // }
                        }

                        let description = value.receivable.description
                        let descriptionDetail = '<span class="bold">' + description + '</span><hr/>' + invoiceDetails
                        parent.total += parseFloat(value.receivable.creditAmount)

                        var categoryLabel = '';
                        if (value.category == 'pay') {
                            categoryLabel = 'Pembayaran';
                            parent.totalPayment += parseFloat(value.receivable.creditAmount);
                        } else if (value.category == 'disc') {
                            categoryLabel = '<span class="red">Potongan</span>';
                            parent.totalDiscount += parseFloat(value.receivable.creditAmount);
                            descriptionDetail = '<span class="bold red">' + description + '</span><hr/><span class="red">' + invoiceDetails + '</span>'
                        }

                        categoryLabel = categoryLabel + '<br/><i>' + value.createdby + '</i>'

                        let deptNamesUnique = _.uniqWith(deptNames, _.isEqual);
                        let payment = {
                            paymentDate: parent.showDateFormatted(value.paymentDate),
                            markingHeaderId: value.markingHeaderId,
                            markingheadercode: value.receivable.marking_minified.markingheadercode,
                            branchcode: value.receivable.marking_minified.subbranchcode,
                            descriptionDetail: descriptionDetail,
                            description: description,
                            descriptionClaim: description,
                            creditAmount: numeral(parseFloat(value.receivable.creditAmount)).format('0,0.00'),
                            categoryLabel: categoryLabel,
                            category: value.category,
                            createdby: value.createdby,
                            deptNames: deptNamesUnique,
                            detailClaim: detailClaim,
                            depositClaim: numeral(depositClaim).format('0,0.00')
                        }
                        payments.push(payment);
                    }

                });

                this.payments = payments;
                this.loadingSearch = false;

                // discount csv
                this.paymentsDiscCsv = _.chain(payments)
                    .filter(function (payment) { return payment.category == 'disc'; })
                    .map(function (object) {
                        const fieldRawCsv = parent.fieldRawCsv.concat(['detailClaim', 'depositClaim'])
                        return _.pick(object, fieldRawCsv);
                    })
                    .value();

                console.log(this.paymentsDiscCsv);

                this.paymentsDiscCsv = this.paymentsDiscCsv.map(function (o) {
                    if (o.detailClaim != '') {
                        o.descriptionClaim = o.detailClaim + ', ' + o.description;
                    }

                    return Object.assign({
                        tanggal: o.paymentDate,
                        marking: o.markingheadercode,
                        cabang: o.branchcode,
                        divisi: o.deptNames[0],
                        deskripsi: o.description,
                        deskripsiClaim: o.descriptionClaim,
                        potongan: o.creditAmount,
                        deposit: o.depositClaim
                    }, _.omit(o, 'paymentDate', 'markingheadercode', 'branchcode', 'deptNames', 'description', 'descriptionClaim', 'creditAmount', 'depositClaim'));
                });

                console.log(this.paymentsDiscCsv);
                // receivables list manual csv
                let vReceivablesList = [];
                _.forEach(receivablesList.data, function (value) {
                    let tempReceivables = {
                        transactionDate: value.transactionDate,
                        markingheadercode: value.marking_header.markingheadercode,
                        branchcode: value.marking_header.subbranchcode,
                        description: value.description,
                        debitAmount: value.debitAmount,
                    }

                    vReceivablesList.push(tempReceivables);

                });

                console.log({ vReceivablesList });

                this.receivablesListCsv = _.chain(vReceivablesList)
                    .map(function (object) { return _.pick(object, parent.fieldRawReceivablesListCsv); })
                    .value();

                this.receivablesListCsv = this.receivablesListCsv.map(function (o) {
                    return Object.assign({
                        Tanggal: o.transactionDate,
                        Marking: o.markingheadercode,
                        Cabang: o.branchcode,
                        Deskripsi: o.description,
                        Piutang: o.debitAmount
                    }, _.omit(o, 'transactionDate', 'markingheadercode', 'description', 'debitAmount'));
                });

                if (payments.length == 0) {
                    this.$Notice.warning({
                        title: 'Pembayaran Tidak Ditemukan',
                        desc: ''
                    });
                }


            }))
            .catch(e => {
                console.log({e});
            })
        },
        getPayment: function () {
            this.loadingSearch = true;
            this.payments = []; // reset data
            this.allPayments = []; // reset all payments
            this.filteredPayments = []; // reset filtered payments
            this.searchQuery = ''; // reset search
            this.currentPage = 1; // reset to first page
            let dateCreateFrom = moment(this.dateFromTo[0], 'YYYY-MM-DD', true)
            let dateCreateTo = moment(this.dateFromTo[1], 'YYYY-MM-DD', true)

            let dateCreateFromValid = dateCreateFrom.isValid() == false ? '' : dateCreateFrom.format("YYYY-MM-DD");
            let dateCreateToValid = dateCreateTo.isValid() == false ? '' : dateCreateTo.format("YYYY-MM-DD");

            this.csvName = this.generateCsvName(dateCreateFromValid, dateCreateToValid)

            this.totalPayment = 0
            this.totalDiscount = 0
            this.total = 0
            this.totalReceivables = 0

            // breakdown per day from dateCreateFrom to dateCreateTo
            let dayToShows = [];

            // Generate array of dates between dateCreateFrom and dateCreateTo
            if (dateCreateFrom.isValid() && dateCreateTo.isValid()) {
                let currentDate = dateCreateFrom.clone();
                while (currentDate.isSameOrBefore(dateCreateTo)) {
                    dayToShows.push(currentDate.format("YYYY-MM-DD"));
                    currentDate.add(1, 'day');
                }
            }

            // Create all promises in parallel
            let totalDays = dayToShows.length;
            let apiCompleted = 0;
            let dataProcessed = 0;
            this.progressGet = 0;

            let promises = dayToShows.map((dayToShow, index) => {
                let payload = {
                    markingHeaderId: this.markingIdSelected,
                    dateCreateFrom: dayToShow,
                    dateCreateTo: dayToShow
                }
                return this.getPaymentParalel(payload)
                    .then(result => {
                        // Track progress after API callback
                        apiCompleted += 1;
                        // Show 0-80% for API calls
                        let apiProgress = Math.round((apiCompleted / totalDays) * 80);
                        this.progressGet = apiProgress;
                        //console.log(`API ${apiCompleted}/${totalDays} finished for: ${dayToShow} (${apiProgress}%)`);
                        return { result: result, day: dayToShow, index: index };
                    });
            });


            // Wait for all promises to complete and process in order
            Promise.all(promises)
                .then(allResults => {
                    // Sort by index to ensure chronological order
                    allResults.sort((a, b) => a.index - b.index);

                    // Process results in order (old to new)
                    allResults.forEach(({ result: paymentData, day, index }) => {
                        console.log('Processing day:', day);
                        this.allPayments.push(...paymentData.payments);
                        this.receivablesListCsv.push(...paymentData.receivablesCsv);
                        this.paymentsDiscCsv.push(...paymentData.paymentsDiscCsv);
                        // this.totalReceivables += paymentData.receivablesTotal.data;
                        this.totalReceivables += (paymentData.receivablesTotal && paymentData.receivablesTotal.data) ? paymentData.receivablesTotal.data : 0;
                        // Track progress after processing each day's data (80-100%)
                        dataProcessed += 1;
                        let processProgress = 80 + Math.round((dataProcessed / totalDays) * 20);
                        this.progressGet = processProgress;
                        //console.log(`Data ${dataProcessed}/${totalDays} processed for: ${day} (${processProgress}%)`);
                    });


                    if(this.allPayments.length == 0){
                        this.$Notice.warning({
                            title: 'Pembayaran Tidak Ditemukan',
                            desc: ''
                        });
                    } else {
                        // Initialize filtered payments with all payments
                        this.filteredPayments = [...this.allPayments];
                    }
                    // Set loading to false and reset progress after processing all data
                    this.loadingSearch = false;
                    this.progressGet = 0;
                })
                .catch(error => {
                    this.loadingSearch = false;
                    console.error('Error fetching payment data:', error);
                });
        },

        getPaymentParalel: function (payload){
            return axios.all([
                this.getPaymentHistory(payload),
                this.getReceivablesListManual(payload),
                this.getReceivablesTotalManual(payload),
            ]).then(axios.spread((paymentHistories, receivablesList, receivablesTotal) => {

                let parent = this;
                let payments = []
                let paymentsDiscCsv = []
                let receivablesCsv = [];

                let paymentData = {
                    payments : [],
                    receivablesCsv : [],
                    paymentsDiscCsv : [],
                    receivablesTotal : 0
                }
                _.forEach(paymentHistories.data, function (value) {
                    let isShow = true;

                    if (parent.isOnlyBca && _.includes(value.receivable.description, 'BCA') == false) {
                        isShow = false
                    }
                    if (isShow) {
                        let invoiceDetails = '';
                        let deptNames = []

                        _.forEach(value.payment_allocate, function (payAllocate) {
                            if (!payAllocate.invoice_due) {
                              parent.$Notice.warning({
                                  title: "Perhatian",
                                  desc: `
                                    Pembayaran ${value.receivable.marking_minified.markingheadercode},
                                    tanggal ${parent.showDateFormatted(value.paymentDate)} tidak ditemukan`,
                                  duration: 0
                              });
                            }

                            if (payAllocate.invoice_due.receivable != null) {
                                let paymentSum = payAllocate.invoice_due.paymentSum
                                paymentSum = numeral(paymentSum).format('0,0.00')

                                let deptName = ""
                                if (payAllocate.invoice_due.receivable.invoice != null) {
                                    deptName = payAllocate.invoice_due.receivable.invoice.item_dept.deptName
                                }

                                deptNames.push(deptName)
                                let invoiceDetail = "- " + deptName
                                invoiceDetail += " - " + payAllocate.invoice_due.receivable.description + " - Rp " + paymentSum
                                invoiceDetails += invoiceDetail + " <br/>"

                            }
                        });

                        // csv potong, detail claim
                        let detailClaim = ''
                        let depositClaim = 0

                        if (value.claim) {
                            value.claim.claim_detail.forEach(o => {
                                detailClaim += o.description
                            })
                            if (value.receivable.type == "DEP") {
                                depositClaim = value.claim.total_claim
                            } else {
                                depositClaim = value.claim.total_claim - value.amount
                            }
                        }

                        let description = value.receivable.description
                        let descriptionDetail = '<span class="bold">' + description + '</span><hr/>' + invoiceDetails
                        parent.total += parseFloat(value.receivable.creditAmount)

                        var categoryLabel = '';
                        if (value.category == 'pay') {
                            categoryLabel = 'Pembayaran';
                            parent.totalPayment += parseFloat(value.receivable.creditAmount);
                        } else if (value.category == 'disc') {
                            categoryLabel = '<span class="red">Potongan</span>';
                            parent.totalDiscount += parseFloat(value.receivable.creditAmount);
                            descriptionDetail = '<span class="bold red">' + description + '</span><hr/><span class="red">' + invoiceDetails + '</span>'
                        }

                        categoryLabel = categoryLabel + '<br/><i style="font-size:10px">' + value.createdby + '</i>'


                        let deptNamesUnique = _.uniqWith(deptNames, _.isEqual);
                        let payment = {
                            paymentDate: parent.showDateFormatted(value.paymentDate),
                            markingHeaderId: value.markingHeaderId,
                            markingheadercode: value.receivable.marking_minified.markingheadercode,
                            branchcode: value.receivable.marking_minified.subbranchcode,
                            descriptionDetail: descriptionDetail,
                            description: description,
                            descriptionClaim: description,
                            creditAmount: numeral(parseFloat(value.receivable.creditAmount)).format('0,0.00'),
                            categoryLabel: categoryLabel,
                            category: value.category,
                            createdby: value.createdby,
                            deptNames: deptNamesUnique,
                            detailClaim: detailClaim,
                            depositClaim: numeral(depositClaim).format('0,0.00')
                        }
                        payments.push(payment);
                    }
                                            console.log(value);

                });




                if (payments.length == 0) {
                    return paymentData
                }

                // discount csv
                paymentsDiscCsv = _.chain(payments)
                    .filter(function (payment) { return payment.category == 'disc'; })
                    .map(function (object) {
                        const fieldRawCsv = parent.fieldRawCsv.concat(['detailClaim', 'depositClaim'])
                        return _.pick(object, fieldRawCsv);
                    })
                    .value();

                paymentsDiscCsv = paymentsDiscCsv.map(function (o) {
                    if (o.detailClaim != '') {
                        o.descriptionClaim = o.detailClaim + ', ' + o.description;
                    }

                    return Object.assign({
                        tanggal: o.paymentDate,
                        marking: o.markingheadercode,
                        cabang: o.branchcode,
                        divisi: o.deptNames[0],
                        deskripsi: o.description,
                        deskripsiClaim: o.descriptionClaim,
                        potongan: o.creditAmount,
                        deposit: o.depositClaim
                    }, _.omit(o, 'paymentDate', 'markingheadercode', 'branchcode', 'deptNames', 'description', 'descriptionClaim', 'creditAmount', 'depositClaim'));
                });

                // receivables list manual csv
                _.forEach(receivablesList.data, function (value) {
                    let tempReceivables = {
                        transactionDate: value.transactionDate,
                        markingheadercode: value.marking_header.markingheadercode,
                        branchcode: value.marking_header.subbranchcode,
                        description: value.description,
                        debitAmount: value.debitAmount,
                    }

                    receivablesCsv.push(tempReceivables);
                });

                receivablesCsv = _.chain(receivablesCsv)
                    .map(function (object) { return _.pick(object, parent.fieldRawReceivablesListCsv); })
                    .value();

                receivablesCsv = receivablesCsv.map(function (o) {
                    return Object.assign({
                        Tanggal: o.transactionDate,
                        Marking: o.markingheadercode,
                        Cabang: o.branchcode,
                        Deskripsi: o.description,
                        Piutang: o.debitAmount
                    }, _.omit(o, 'transactionDate', 'markingheadercode', 'description', 'debitAmount'));
                });


                paymentData.payments = payments,
                paymentData.receivablesCsv = receivablesCsv,
                paymentData.paymentsDiscCsv = paymentsDiscCsv,
                paymentData.receivablesTotal = receivablesTotal

                return paymentData
            }))
            .catch(e => {
                // dihandle dengan notifikasi : pembayaran tidak ditemukan
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
                console.log({e});
                return paymentData
            })
        },

        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.subbranchcode
                        })
                        .then(response => {

                            this.invoiceDues = []
                            this.amountResidue = ''
                            this.amountReceived = ''
                            this.description = ''

                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.loadingGetMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        showSearchButton: function () {
            // marking diisi atau tanggal diisi
            if ((this.markingIdSelected != '') || ((this.dateFromTo[0] != '' && this.dateFromTo[0] != null))) {
                return true
            }
            return false
        },
    },
}

</script>
<style>
.bold {
    font-weight: bold;
}

.red {
    color: red;
}
</style>



// WEBPACK FOOTER //
// PaymentList.vue?fae8a5d2